/* eslint-disable no-console */
import './Index.scss'

import React from 'react'
import { Link } from 'react-router'
import SearchInput from 'react-search-input'
import ReactTooltip from 'react-tooltip'
import AgentRow  from './AgentRow'
import { connectModal } from 'redux-modal'
import CashbackTermsAndConditions from 'broker/views/components/CashbackTermsAndConditions'
import { get } from 'common/util/helper'
import {search, hasUnpaidCloses, fetchAccountAgentsPaged, fetchOverdueAgents} from 'broker/redux/account'
import { handleDeepRoute } from 'broker/redux/deep_route'
import SimplifyingGoogleMap from 'common/views/components/SimplifyingGoogleMap'
import RemoveAgent from '../common/RemoveAgentModal'
import { selectNewBrokerPortalCashbackTerms } from 'broker/selectors/auth'
import { selectIsMasquerade } from 'common/redux/selectors/auth'

import { BLA_STATUSES } from 'common/constants'

import { segmentEventTracker } from 'common/analytics'
import {Pagination} from "broker/views/components/common/Pagination";
import Select from "react-select";

class DelinquentNotice extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      showDelinquentNotice: true
    }
  }

  handleHide = () => {
    this.setState({
      showDelinquentNotice: false
    })
  }

  render() {
    const { account } = this.props
    const { bla_status } = account
    const { showDelinquentNotice } = this.state

    const isBrokerBla = !!bla_status

    const isBrokerBlaDelinquent = isBrokerBla && (bla_status === BLA_STATUSES.DELINQUENT || bla_status === BLA_STATUSES.SUSPENDED)

    const hasMonthlyFee = account.has_overdue_monthly_fee
    const hasReferralFee = account.has_overdue_referral_fees
    const hasAllOutstandingTransactionsInReview = account.has_all_outstanding_transactions_exempt_from_collections

    let message
    let messageTitle

    let referralFeeMessageTitle
    let monthlyFeeMessageTitle
    let mvipLeadsOverdueContractsMessageTitle

    let uploadClosingDocumentsMessage = `We have now removed the requirement to submit closing documents for Market VIP transactions. 
    Eligible buyer incentives are not sent out for ReadyConnect Concierge until we have received closing payments and/or documents, 
    where applicable. Help us help your customers! Thank you.
    `

    let uploadBLADocumentsMessage = `We have stopped working new BLA leads from your brokerage and will send new referrals
    from your existing brokerage leads to third-party agents in the Opcity network`

    if (hasReferralFee) {
      let referralFeeMessageTitleStr = `You
       have ${hasReferralFee} closed Ready Connect Concierge
       lead${(hasReferralFee > 1 ? 's' : '')} ready for payment and/or documents.`

      referralFeeMessageTitle = (
        <span>
          {referralFeeMessageTitleStr}
        </span>
      )
    }
    if (hasMonthlyFee) {
      monthlyFeeMessageTitle = (
        <span>
          You have monthly BLA fees overdue for payment.
        </span>
      )
    }

    messageTitle = (
      <div>
        Notice
        <ul>
          {referralFeeMessageTitle && (
            <li>
              {referralFeeMessageTitle}
            </li>
          )}
          {monthlyFeeMessageTitle && (
            <li>
              {monthlyFeeMessageTitle}
            </li>
          )}
          {mvipLeadsOverdueContractsMessageTitle && (
            <li>
              {mvipLeadsOverdueContractsMessageTitle}
            </li>
          )}
        </ul>
      </div>
    )

    if ( hasReferralFee && hasMonthlyFee ){
      message = (
        <span>
          {uploadClosingDocumentsMessage}
          <br/><br />
          Please visit our <a href="https://support.realtor.com/s/article/My-agent-just-closed-a-transaction-How-do-I-make-sure-they-get-credit-for-their-close">Support Portal</a> for information on how to submit payments.
          <br/><br/>
          {uploadBLADocumentsMessage}
        </span>
      )
    }
    else if (hasReferralFee) {
      message = (
        <span>
          {uploadClosingDocumentsMessage}
          <br/><br />
          Please visit our <a href="https://support.realtor.com/s/article/My-agent-just-closed-a-transaction-How-do-I-make-sure-they-get-credit-for-their-close">Support Portal</a> for information on how to submit payments.
        </span>
      )
    }
    else if (isBrokerBla && isBrokerBlaDelinquent && hasMonthlyFee) {
      message = (
        <span>
          {uploadBLADocumentsMessage}
        </span>
      )
    }
    else if (!hasMonthlyFee && !hasReferralFee) {
      message = (
        <span>
          If payment is not received, Opcity reserves the right to stop sending your agents leads at any time.
          If you have already sent your payment, please allow two weeks for payment processing.
        </span>
      )
    }

    const delinquentNotice = (
      <div className="DelinquentNotice">
        <div className="DelinquentNotice__body">
          <div className="DelinquentNotice__title">
              <h3>{messageTitle}</h3>
          </div>
          <div>
            {message}

            { hasReferralFee || hasMonthlyFee ? ' ' : ''}

            { hasReferralFee &&
              <span><Link to={{pathname:"/unpaid-closes"}}>View your outstanding referrals.</Link></span>
            }

            { hasReferralFee && hasMonthlyFee ? ' ' : ''}

            { hasMonthlyFee &&
              <span>Please contact <a href="mailto:samantha.vanorman@opcity.com">Samantha Van Orman</a> to discuss your monthly payment status.</span>
            }
          </div>
        </div>
        <span className="fa fa-times-circle close-icon" onClick={() => {this.handleHide()}}></span>
      </div>
    )

    const hasFeesOrOverdueContracts = hasReferralFee || hasMonthlyFee
    const showDelinquentNoticeBanner = !hasAllOutstandingTransactionsInReview && showDelinquentNotice && hasFeesOrOverdueContracts
    return showDelinquentNoticeBanner ? delinquentNotice : null
  }
}

const OverdueAgents = ({account}) => {
  function renderRow(item, idx) {
    return <tr key={idx}>
      <td>{ item.agent_name}</td>
      <td className="-danger">{ item.count}</td>
      <td className="-danger">{ item.disabled_since_days} days</td>
    </tr>
  }

  return <div className="-panel">
    <div className="-panel-title -underline"><div className="-underline" data-tip="Agents that are over 7 days overdue on updating their Referral Manager">Overdue Agents</div></div>
    <table className="-table-sm">
      <thead>
        <tr>
          <th>Name</th>
          <th>Transactions</th>
          <th>Overdue</th>
        </tr>
      </thead>
      <tbody>
        { account.overdue_agents ? account.overdue_agents.map(renderRow) : null }
      </tbody>
    </table>
  </div>
}

const MyAgents = ({account, dispatch, auth}) => {

  const user = auth? auth.user : undefined
  const hideAgentTrainingStat = user ? user.hide_agent_training_stat : false

  const activeAgentsCopy = `The total number of agents eligible to receive leads. Includes ${account.experienced_agents_count} experienced and ${account.emerging_agents_count} emerging agents.`
  const inactiveAgentsCopy = `The total number of agents that are delinquent or not currently receiving leads. Includes ${account.inactive_agents_experienced} experienced and ${account.inactive_agents_emerging} emerging agents.`
  const overdueAgentsCopy = `The total number of agents that are overdue in updating their referral manager. Agents are considered overdue after 7 days of no updates on a transaction. Includes ${account.overdue_agents_experienced} experienced and ${account.overdue_agents_emerging} emerging agents.`
  let completedTraining

  if(!hideAgentTrainingStat) {
    completedTraining = <div className="MyAgents__col MyAgents__col" data-tip={`Includes ${account.total_webinar_experienced} experienced agents and ${account.total_webinar_emerging} emerging agents`}>
        <div className="MyAgents__label">Completed Training</div>
        <div className="MyAgents__value">
        <div className="MyAgents__webinar"></div>
      {(account.total_webinar_completed || 0) + '%'}
        </div>
        </div>
  } else {
    completedTraining = <div/>
  }
  return <div className="MyAgents -panel">
    <div className="-panel-title">My Agents</div>
    <div className="MyAgents__map">{ account.geo_json && <SimplifyingGoogleMap geoJsonData={account.geo_json} dispatch={dispatch} /> }</div>
    <div className="MyAgents__body">
      <div className="MyAgents__col MyAgents__col" data-tip={activeAgentsCopy}>
        <div className="MyAgents__label -underline">Active Agents</div>
        <div className="MyAgents__value">{ account.active_agents_count }</div>
      </div>
      <div className="MyAgents__col MyAgents__col" data-tip={inactiveAgentsCopy}>
        <div className="MyAgents__label -underline">Inactive Agents</div>
        <div className="MyAgents__value">{ account.inactive_agents_count }</div>
      </div>
      <div className="MyAgents__col MyAgents__col" data-tip={overdueAgentsCopy}>
        <div className="MyAgents__label -underline">Overdue Agents</div>
        <div className="MyAgents__value">{ account.overdue_agents_count }</div>
      </div>
      {completedTraining}
      <div className="MyAgents__col MyAgents__col">
        <div className="MyAgents__label">Using Mobile App</div>
        <div className="MyAgents__value">
          <div className="MyAgents__mobile-app"></div>
          { (account.total_mobile_enabled || 0 )+ '%' }
        </div>
      </div>
    </div>
    <hr />
    <button onClick={() => {
      segmentEventTracker('Navigation-Button Clicked', {
        'navigated_to': '/add-users',
        'button_text': 'Add Agent'
      }, null, null, () => {
        window.location = '/add-users'
      })
    }} className="Index btn btn-success">Add Agent</button>
  </div>
}

const RecentActivity = ({dispatch, account}) => {

  function renderRow(item, idx) {
    return <div className="RecentActivity__item" key={idx}>
      <div className="RecentActivity__value"><i className="fa fa-circle-o" /><a onClick={() => dispatch(search({searchTerm:item.agent_name}))}>{ item.agent_name}</a> was referred a client</div>
      <div className="RecentActivity__subvalue">{ item.time_since }</div>
    </div>
  }

  const activityList = account.recent_activity ? <div className="RecentActivity__outer">
    <div className="RecentActivity__inner">
    { account.recent_activity.map(renderRow) }
    </div>
  </div> : null

  return <div className="RecentActivity -panel -panel--no-bottom">
    <div className="-panel-title">Recent Activity</div>
    { activityList }
  </div>
}

const PipelineVolume = ({account, auth}) => {
  function getTargetClassname(target, actual) {
    return actual < (target * .7) ? '-danger' : ''
  }

  return <div className="PipelineVolume -panel">
    <div className="-panel-title">
      My Brokerage
      <span className="PipelineVolume__last-generated-at">{account.stats_last_generated_at ? 'last updated: ' + account.stats_last_generated_at : null}</span>
    </div>
    <h2>Overview</h2>
    <div className="PipelineVolume__row">
      <div className="PipelineVolume__item">
        <div className="PipelineVolume__label"><div className="-underline" data-tip="The total dollar amount of transactions that your agents are ‘Actively Working’ and in the ‘Spoke’ stage or later.">Active Pipeline</div></div>
        <div className="PipelineVolume__value -success -large">${ account.actual_volume }</div>
      </div>
      <div className="PipelineVolume__item">
        <div className="PipelineVolume__label"><div className="-underline" data-tip="Active transactions reported to be at the stage of making offers or under contract.">Likely Closes</div></div>
        <div className="PipelineVolume__value -large">{ account.likely_to_close }</div>
      </div>
      <div className="PipelineVolume__item">
        <div className="PipelineVolume__label"><div className="-underline" data-tip="The number of transactions that are currently assigned to your agents that have not closed or have not been released. This includes transactions that are on Long-Term Hold and are overdue. This could be larger than the number of your Referrals since a single referral can lead to a sell transaction and a separate buy transaction.">Assigned Transactions</div></div>
        <div className="PipelineVolume__value -large">{ !isNaN(account.working + account.on_hold + account.need_update) ? account.working + account.on_hold + account.need_update : 0 }</div>
      </div>
    </div>
    <div className="PipelineVolume__row">
      <div className="PipelineVolume__item">
        <div className="PipelineVolume__label"><div className="-underline" data-tip="The number of transactions that are currently assigned to your agents that are not on hold or are not overdue for an update.">Actively Working</div></div>
        <div className="PipelineVolume__value">{ account.working }</div>
      </div>
      <div className="PipelineVolume__item">
        <div className="PipelineVolume__label"><div className="-underline" data-tip="The total number of transactions that are currently set to Long-Term Hold by your agents.">Currently On Hold</div></div>
        <div className="PipelineVolume__value -warning">{ account.on_hold }</div>
      </div>
      <div className="PipelineVolume__item">
        <div className="PipelineVolume__label"><div className="-underline" data-tip="Total # of transactions that are least 7 days overdue for a progress update in that agent's Referral Manager.">Overdue for Update</div></div>
        <div className="PipelineVolume__value -danger">{ account.need_update }</div>
      </div>
    </div>
    <hr/>
    <h2>Referral Pipeline</h2>
    <div className="PipelineVolume__row">
      <div className="PipelineVolume__pipeline">
        <table>
          <thead>
            <tr>
              <th>% of referred clients who...</th>
              <th width="110">My Agents</th>
              <th width="110">Top 10% Brokers</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="PipelineVolume__small">Met/House Hunted</td>
              <td className={getTargetClassname(account.met_target_percent, account.met_percent)}>{ account.met_percent }%</td>
              <td>{ account.met_target_percent }%</td>
            </tr>
            <tr>
              <td className="PipelineVolume__small">Made Offers</td>
              <td className={getTargetClassname(account.offers_target_percent, account.offers_percent)}>{ account.offers_percent }%</td>
              <td>{ account.offers_target_percent }%</td>
            </tr>
            <tr>
              <td className="PipelineVolume__small">Under Contract</td>
              <td className={getTargetClassname(account.contract_target_percent, account.contract_percent)}>{ account.contract_percent }%</td>
              <td>{ account.contract_target_percent }%</td>
            </tr>
            <tr>
              <td className="PipelineVolume__small">Closed</td>
              <td className={getTargetClassname(account.closed_target_percent, account.closed_percent)}>{ account.closed_percent }%</td>
              <td>{ account.closed_target_percent }%</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <hr/>
    <h2>Closes</h2>
    <div className="PipelineVolume__row">
      <div className="PipelineVolume__item">
        <div className="PipelineVolume__label"><div className="-underline" data-tip="Total dollar volume of transactions reported closed by your agents.">Closed Volume</div></div>
        <div className="PipelineVolume__value -success">${ account.actual_amount }</div>
      </div>
      <div className="PipelineVolume__item">
        <div className="PipelineVolume__label"><div className="-underline" data-tip="Total # of transactions reported closed by your agents.">Closed Transactions</div></div>
        <div className="PipelineVolume__value -success">{ account.closed }</div>
      </div>
    </div>
    <hr/>
    <h2>7-Day Referral Alert Engagement</h2>
    <div className="PipelineVolume__row">
      <div className="PipelineVolume__item">
        <div className="PipelineVolume__label"><div className="-underline" data-tip="Total # of text message opportunities sent to your team.">Total Alerts Sent</div></div>
        <div className="PipelineVolume__value">{ get(account.stats_sent_count, '-') }</div>
      </div>
      <div className="PipelineVolume__item">
        <div className="PipelineVolume__label"><div className="-underline" data-tip="Total # of text message opportunities that your team attempted to win.">Alerts Clicked</div></div>
        <div className="PipelineVolume__value">{ get(account.stats_clicked_count, '-') }</div>
      </div>
      <div className="PipelineVolume__item">
        <div className="PipelineVolume__label"><div className="-underline" data-tip="Total # of text message opportunities that your team clicked and won.">Alerts Won</div></div>
        <div className="PipelineVolume__value">{ get(account.stats_won_count, '-') }</div>
      </div>
    </div>
    <div className="PipelineVolume__row">
      <div className="PipelineVolume__item">
        <div className="PipelineVolume__label"><div className="-underline" data-tip="For all text message alerts in the past 7 days, your team's average time from text message alert sent to clicked.">Team Avg Click Time</div></div>
        <div className="PipelineVolume__value">{ get(account.stats_avg_click_time, '-') }</div>
      </div>
      <div className="PipelineVolume__item">
        <div className="PipelineVolume__label"><div className="-underline" data-tip="For all text message alerts your team won in the past 7 days, your team's average time from text message alert sent to clicked.">Team Avg Won Click Time</div></div>
        <div className="PipelineVolume__value">{ get(account.stats_avg_won_click_time, '-') }</div>
      </div>
    </div>
  </div>
}

const RemoveAgentModal = connectModal({ name: 'RemoveAgentModal', destroyOnHide: true })(RemoveAgent)

const AgentList = ({props, pageNumber, filterOptions, selectedFilter, fetchAgentsPaged, searchTerm}) => {
  const {account} = props

  const renderRow = (agent) => {
    return <AgentRow
      agent={agent}
      rank={agent.idx}
      key={agent.id}
      {...props}
    />
  }

  const filteredAgents = account.agents ? account.agents : []
  const setPage = (page_number) => {
    if(page_number >= 1 && page_number <= account.agents_nav.max_page) {
       fetchAgentsPaged(page_number, selectedFilter, searchTerm)
    }
  }

  return <div className="AgentList -panel">
    <div className="-panel-title -panel-title--no-bottom">Agent Pipelines</div>
    <div className="-row-between">
      <div className="-row-start">
        <SearchInput
          className="SearchInput glyphicon glyphicon-search"
          value={account.searchTerm}
          onChange={(term) => fetchAgentsPaged(1, selectedFilter, term)}
          onClick={() => { segmentEventTracker('User Searched', { 'user_type': 'agent' }) }}
        />
        <div className="selectStyle">
          <Select
            clearable={false}
            searchable={false}
            options={filterOptions}
            value={selectedFilter}
            onChange={(filter) => {
              fetchAgentsPaged(1, filter, searchTerm)
            }}
          />
        </div>


        <div className="AgentList__download" onClick={() => {
          segmentEventTracker('Data Downloaded', { 'downloaded_data': 'agent_pipeline' })
        }}><a href="/download/agents"><i className="fa fa-download" aria-hidden="true"></i> Download</a></div>
      </div>

      <div className="-row-end">
        <Pagination
          nav={account.agents_nav}
          pageForward={() => setPage(pageNumber + 1)}
          pageBackward={() => setPage(pageNumber - 1)}
          pageToFirst={() => setPage(1)}
          pageToLast={() => setPage(account.agents_nav.max_page)}
        />
      </div>

    </div>
    <div className="AgentList__banner">
      <h3 className="AgentList__banner-title"><i className="fa fa-line-chart"></i>ReadyConnect Concierge Performance</h3>
      <div className="AgentList__banner-content">At this time, agents with the <span className="AgentList__banner-content-highlight">highest claim rates and close rates in the last 12 months</span> in their market are most likely to receive ReadyConnect Concierge leads. Volume may vary based on market conditions. <a href="https://support.realtor.com/s/article/How-Can-I-Be-Successful-on-the-Platform">Learn more about performance</a></div>
    </div>
    <div className="AgentList__body">
      { filteredAgents.map(renderRow)}
    </div>
  </div>
}

class LeadPromoBanner extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      showPromo: true
    }
  }

  handleHide = () => {
    this.setState({
      showPromo: false
    })
  }

  render() {
    const { showPromo } = this.state

    const promo = (
      <div className="LeadPromoBanner">
        <div className="LeadPromoBanner__lead-promo">
          <div className="LeadPromoBanner__lead-promo--logo">
            <div></div>
          </div>
          <div className="LeadPromoBanner__lead-promo--txt-wrapper">
            <h3>Turn Your Leads into Closed Deals!</h3>
            <div className="LeadPromoBanner__lead-promo--sub-text">
              Are you generating online leads and still not seeing the conversion and commissions you want?
              We can take your leads and turn them into closed transactions for you!
            </div>
            <div>
              <a href="https://marketing.realtor.com/accelerator" target="_blank" rel="noopener noreferrer">Learn more here</a>
            </div>
          </div>
          <span className="fa fa-times-circle LeadPromoBanner__promo-icon" onClick={() => {this.handleHide()}}></span>
        </div>
      </div>
    )

    return (
      <div>
        { showPromo && promo }
      </div>
    )
  }
}

class Index extends React.Component {

  constructor(props) {
    super(props)
    const filter_options = [
        {value: 'all_agents', label: 'All Agents'},
        {value: 'your_agents', label: 'Your Agents'},
        {value: 'active_agents', label: 'Active Agents'},
        {value: 'inactive_agents', label: 'Inactive Agents'},
        {value: 'overdue_agents', label: 'Overdue Agents'},
        {value: 'emerging_agents', label: 'Emerging Agents'},
        {value: 'experienced_agents', label: 'Experienced Agents'},
        {value: 'all_former_agents', label: 'All Terminated Agents'},
        {value: 'former_agents_with_active_transactions', label: 'Terminated Agents with Active Transactions'},
      ]
    this.state = {
      pageNumber: 1,
      selectedFilter: filter_options[2],
      filter_options: filter_options,
      searchTerm: "",
    }
    this.props.dispatch(hasUnpaidCloses())
    this.props.dispatch(handleDeepRoute())
    this.props.dispatch(fetchOverdueAgents())
    this.props.dispatch(fetchAccountAgentsPaged(this.state.pageNumber, this.state.selectedFilter.value))

  }

  fetchAgentsPaged(pageNumber = this.state.pageNumber, filter= this.state.selectedFilter, searchTerm = this.state.searchTerm) {
      this.setState({selectedFilter: filter, pageNumber: pageNumber, searchTerm: searchTerm})
      this.props.dispatch(fetchAccountAgentsPaged(pageNumber, filter.value, searchTerm))
  }

  renderLoadingState = () => {
    return (
      <div className="Index pulse">
        <div className="Index__container">
          <div className="Dummy-container"></div>
        </div>
      </div>
    )
  }


  render() {
    if(!this.props.account.actual_volume) {
      return this.renderLoadingState()
    }

    // These are used for the terms and conditions component
    const { auth } = this.props
    const { user } = auth
    const { acknowledged_terms_conditions_at } = user

    const hasCashbackTerms = selectNewBrokerPortalCashbackTerms({...this.props})
    const userIsMasqueraded = selectIsMasquerade({...this.props})

    return (
      <div className="Index">
        <ReactTooltip effect="solid" multiline={true} className="Index__tooltip"/>
        <RemoveAgentModal {...this.props} />

        { hasCashbackTerms && !acknowledged_terms_conditions_at && !userIsMasqueraded ?
          <div className="Index__container">
            <CashbackTermsAndConditions {...this.props} />
          </div>
        :
          <div className="Index__container">
            <DelinquentNotice {...this.props} />
            
            <div className="Index__left">
              <PipelineVolume {...this.props} />
              <AgentList
                props={this.props}
                pageNumber={this.state.pageNumber}
                selectedFilter={this.state.selectedFilter}
                filterOptions={this.state.filter_options}
                fetchAgentsPaged={(pageNumber, filter, term) => this.fetchAgentsPaged(pageNumber, filter, term)}
                searchTerm={this.state.searchTerm}
                />
            </div>
            <div className="Index__right">
              <OverdueAgents {... this.props}/>
              <MyAgents {...this.props} />
              <RecentActivity {...this.props} />
            </div>
          </div>
        }
      </div>
    )
  }
}

export default Index
